import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  open: false,
  query: '',
  results: [],
};

/**
 * player in state
 */
export const search = handleActions(
  {
    OPEN_SEARCH: (state, action) => {
      return Object.assign({}, state, {
        open: true,
        query: '',
        results: []
      });
    },
    CLOSE_SEARCH: (state, action) => {
      return Object.assign({}, state, {
        open: false
      });
    },
    UPDATE_SEARCH_QUERY: (state, action) => {
      return Object.assign({}, state, {
        query: action.payload
      });
    },
    REPLACE_SEARCH_RESULTS: (state, action) => {
      return Object.assign({}, state, {
        results: action.payload
      });
    },
    CLEAR_SEARCH: () => INITIAL_STATE,
  },
  INITIAL_STATE
);



// WEBPACK FOOTER //
// ./src/reducers/search.js